module.exports = __webpack_public_path__ + "static/fonts/PorscheNextTT-ThinBoldItalic.d80cca3a.ttf";